import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ConfigurationService } from '../../system-configuration';
import { UserProfileSettingsService } from '../../system-services/UserProfileSettings';

@Directive({
    selector: '[maskInLogRocket]',
    standalone: false
})
export class LogRocketMaskingDirective {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private config: ConfigurationService,
        private userProfile: UserProfileSettingsService
    ) {
        if (this.shouldMaskCogData()) {
            this.renderer.setAttribute(
                this.el.nativeElement,
                'data-private',
                'lipsum'
            );
        }
    }

    private shouldMaskCogData(): boolean {
        try {
            const selectedCompanyGuid =
                this.userProfile.getCurrentCompanySettings().companyId;

            const hideForCompaniesList =
                this.config.getCompanyGuidsWithMaskedCogData();

            return hideForCompaniesList.includes(selectedCompanyGuid);
        } catch (e) {
            console.error(
                'Data that needs to be masked for a given list of companies are misconfigured'
            );
            console.error(e);
        }

        return false;
    }
}
